import instance from 'src/api/instance';
import { LoginRequestModel } from 'src/models/auth';

export async function loginService(data: LoginRequestModel) {
  const response = await instance.post<any>('/login', data);
  return response;
}

export async function logoutService() {
  const uuid = localStorage.getItem('device_id');
  const response = await instance.post<any>('/logout', {
    device_id: uuid
  });
  return response;
}
